// import React from "react";
import React, { useState } from 'react';
import 'react-calendar/dist/Calendar.css';
// import Calendar from 'react-calendar';
import { NavLink, Link } from 'react-router-dom';
import axios from "axios";
import Moment from "react-moment";
import parse from "html-react-parser";
import ScrollToTop from './ScrollToTop';
import { Calendar, momentLocalizer } from "react-big-calendar";
import TwitterEmbed from "../../src/TwitterEmbed.js";
import moment from "moment";
import { LinkedInEmbed  } from 'react-social-media-embed';
const GLOBAL = require('../commonConstants.js');
const localizer = momentLocalizer(moment);
const url = GLOBAL.BASE_URL+"events";

const Footer = () => {
  const [value, onChange] = useState(new Date());
  const [getEvents, setEvents] = React.useState(null);
  const [getValue, setValue] = React.useState(null);
  var copy = [];
  var copy1 = [];
  for (let x in getEvents) {
    if (getEvents[x].isgf_event == 0) {
      var c = {
        allDay: false,
        end: new Date(getEvents[x].start_date),
        start: new Date(getEvents[x].end_date),
        title: getEvents[x].title,
      };
      copy.push(c);
    } else {
      var c1 = {
        allDay: false,
        end: new Date(getEvents[x].start_date),
        start: new Date(getEvents[x].end_date),
        title: getEvents[x].title,
      };
    }
    copy1.push(c1);
  }

  const myEventsList = copy1;
  const myEventsList1 = copy;
  const re_calc = () => {
    var step1 = document.querySelector("#event-1");
    var step2 = document.querySelector("#event-2");
    step1.style.display = "none";
    step2.style.display = "block";
  };
  const again_calc = () => {
    var step1 = document.querySelector("#event-1");
    var step2 = document.querySelector("#event-2");
    step1.style.display = "block";
    step2.style.display = "none";
  };
  var getValue1 = '';
  if(getValue != null){
    getValue1 = getValue;
  }else{
    getValue1 = 4;
  }
  // console.log(new_url);
  React.useEffect(() => {
  const new_url = url + "?id=" + getValue1;
    axios.get(new_url).then((response) => {
    setEvents(response.data);
     });
    window.scrollTo(0, 0);

   },[getValue1]);
  if (!getEvents) return null;
  // console.log(getEvents);

  return (
    <>

      <div   className="footer sec-padd" style={{backgroundImage: `url(${process.env.PUBLIC_URL + '/images/footer.jpg'})`}}>
        <div className="container">
          <div className="row g-4">
            <div className="col-md-3">
              <div className="heading mb-3">
                <h2>LinkedIn</h2>
              </div>
              <p className='mb-4'>Follow us on LinkedIn</p>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 60 }}>
                <a
                  href="https://www.linkedin.com/in/india-smart-grid-forum/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ display: 'inline-flex', alignItems: 'center', gap: 8, textDecoration: 'none', color: 'black', fontWeight: 500, fontSize: 16 }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" style={{ width: 32, height: 32, fill: 'black' }}>
                    <path d="M100.28 448H7.4V148.9h92.88zm-46.44-340.7C24.12 107.3 0 83.2 0 53.6A53.6 53.6 0 0 1 53.6 0a53.6 53.6 0 0 1 53.6 53.6c0 29.6-24.12 53.7-53.36 53.7zM447.8 448h-92.4V302.4c0-34.7-12.4-58.4-43.4-58.4-23.7 0-37.8 16-44 31.4-2.3 5.6-2.8 13.4-2.8 21.2V448h-92.4s1.2-241.2 0-266.1h92.4v37.7c12.3-19 34.3-46.1 83.5-46.1 60.9 0 106.6 39.8 106.6 125.4V448z"/>
                  </svg>
                  <span style={{color:'black'}}>@IndiaSmartGridF</span>
                </a>
              </div>
              <hr />
            </div>
            <div className="col-md-3">
              <div className="heading mb-3">
                <h2>Tweets</h2>
              </div>
              <p className='mb-4'>Follow us on X (Twitter)</p>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 60 }}>
                <a
                  href="https://twitter.com/IndiaSmartGridF"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ display: 'inline-flex', alignItems: 'center', gap: 8, textDecoration: 'none', color: '#000', fontWeight: 500, fontSize: 16 }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style={{ width: 32, height: 32, fill: 'black' }}>
                    <path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"/>
                  </svg>
                  <span>@IndiaSmartGridF</span>
                </a>
              </div>
              <hr />
            </div>

          <div className="col-md-3">
          <div className="heading mb-3">
                <h2>Events Calendar</h2>
              </div>
          <div className="c-tab">
                <button onClick={re_calc} className="btn btn-tab">
                  ISGF Events
                </button>
                <button  onClick={again_calc} className="btn btn-tab">
                  Global Events
                </button>
              </div>
              <div className="calendar">
                  <div className="calendar-1 text-center" id="event-1">
                    <Calendar
                      localizer={localizer}
                      events={myEventsList}
                      startAccessor="start"
                      endAccessor="end"
                      style={{ height: 390 }}
                      popup={true}
                    />
                  </div>
                  <div
                    className="calendar-1 text-center"
                    style={{ display: `none` }}
                    id="event-2"
                  >
                    <Calendar
                      localizer={localizer}
                      events={myEventsList1}
                      startAccessor="start"
                      endAccessor="end"
                      style={{ height: 400 }}
                      popup={true}
                    />
                  </div>
                </div>
          </div>

            <div className="col-md-3 contact">
              <div className="heading mb-3">
                <h2>Contact Us</h2>
              </div>
              <p>
              <span className='icon-footer'><i className="fa fa-map-marker"></i></span>
              <span><strong>India Smart Grid Forum</strong><br/>
                CBIP Building,Malcha Marg, Chanakyapuri, Delhi-110021</span>
              </p>
              <p>
              <span className='icon-footer'><i className="fa fa-phone"></i></span>
              <span><strong>Phone</strong>
                <br />
                <a href="tel:+91-114103 0398" className="contact-email">+91-114103 0398</a></span>

              </p>
              <p>
              <span className='icon-footer'><i className="fa fa-envelope"></i></span>
              <span><strong>Email</strong>
                <br />
                <a href="mailto:contactus@indiasmartgrid.org" className="contact-email">contactus@indiasmartgrid.org</a></span>

              </p>
              <NavLink onClick={() => window.scrollTo(0, 0)} to="/contact-us" className="btn btn-tab d-block mt-md-4 more-information">
                Click For More Information
              </NavLink>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-sm">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center" onClick={() => window.scrollTo(0, 0)}>
              <NavLink to="#">Sitemap</NavLink> |{" "}
              <Link to="/guidelines-and-policy">Guidelines & Policy</Link> |{" "}
              <NavLink  to="/disclaimer">Disclaimer</NavLink> |{" "}
              <NavLink to="/privacy-policy">Privacy Policy</NavLink> |{" "}
              <NavLink to="/terms-conditions">Terms and Conditions</NavLink> |{" "}
              <NavLink to="/refund-and-cancellation">Refund and Cancellation</NavLink>
            </div>
            <div className="col-md-4 text-md-end"></div>
          </div>
        </div>
      </div>

    </>
  );
};

export default Footer;
